/*
 * File: Asana.tsx
 * Project: a-a
 * File Created: Tuesday, 22nd April 2025 1:29:19 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Tuesday, 22nd April 2025 1:54:51 pm
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import { Box, Divider, Typography } from '@mui/material';
import React from 'react';
import zeplinColor from '../../theme/Color';
import CustomCard from '../../components/shared/CustomCard/CustomCard';
import AsanaHome from '../../components/featured/Asana/AsanaHome.tsx/AsanaHome';

const Asana = () => {
  return (
    <Box>
      <AsanaHome />
    </Box>
  );
};

export default Asana;
